<template>
  <v-row>
    <v-col
      cols="12"
      :md="emitResult ? '12' : '8'"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="model.firstName"
                type="text"
                label="First name"
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="model.lastName"
                type="text"
                label="Last name"
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="model.email"
                type="text"
                label="Email"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <international-phone-number
                @change="onPhoneNumberChange"
                :hide-details="true"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                hide-details
                outlined
                dense
                v-model="model.description"
                type="text"
                label="Description"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="4"
    />

    <v-col cols="12">
      <v-divider class="my-3" />
      <v-btn
        :loading="isLoading"
        :disabled="isLoading"
        rounded
        color="primary"
        outlined
        @click="save"
      >
        Save
      </v-btn>
      <v-btn
        v-if="!emitResult"
        :disabled="isLoading"
        rounded
        text
        @click="$router.go(-1)"
      >
        Cancel
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
import InternationalPhoneNumber from "../Common/InternationalPhoneNumber"

export default {
  components: { InternationalPhoneNumber },
  props: {
    emitResult: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions([ 'createCustomer']),
    onPhoneNumberChange(phone){
      this.model = {
        ...this.model,
        phoneNumber: phone.number
      }
    },
    async save() {
      const payload = { ...this.model }

      this.isLoading = true
      const response = await this.createCustomer(payload)
      this.isLoading = false
      const { id } = response

      if (id) {
        if (this.emitResult) {
          this.$emit('created-customer', response)
        } else {
          this.$router.push({ name: 'customer-detail', params: { id }})
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      model: {
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        description: undefined
      },
    }
  },
}
</script>
